import { createFileRoute } from '@tanstack/react-router';
import { RulesPage } from '@/components/finance';

// Read-only view of the jurisdiction's ruleset file. The sub-nav hides the tab
// from users without Finance.Manage, and the source endpoint enforces the same
// capability itself, so reaching this URL directly shows a load error, not the file.
export const Route = createFileRoute('/admin/finance/settings/rules')({
  component: RulesPage,
});
